export default class OverviewValues {
  constructor() {
    this.cash = 0;
    this.value = 0;
    this.isLoaded = false;
  }

  loadData(payload) {
    this.isLoaded = true;

    if (payload && payload.length > 0) {
      this.cash = payload[0].cash;
      this.value = payload[0].value;

      return;
    }

    this.cash = 0;
    this.value = 0;
  }
}
